import React, { Component } from 'react';
import { Icon, Form, Tabs, Table, Tooltip, message, Modal, Button, Spin } from 'antd';
import moment from 'moment';
import './referral.scss';
import { getCommonColumnInfoFn,requestErrorLog } from '@/common/util';
import { getReferralData, getCancelReferral, getDeleteReferred, getExamInfo } from '@/request/api';
import ReferralPatient from './referralPatient';
import ReferralQueryFrom from './components/referralQueryFrom';
import ApplyReferral from './components/applyReferral';
import EditTable from '@/components/editTable/index';
import addReferral from '@/assets/image/addReferral.png';
import replyicon from "@/assets/image/replyicon.png";
import noapplyicon from "@/assets/image/noapplyicon.png";


const { TabPane } = Tabs;
const { confirm } = Modal;
class ReferralApply extends Component {
	state = {
		percent: 0,
		refreshTimeNum: 0,
		departmentList: [],//申请科室
		showColumn: false, //编辑表头,
		RowCount: 0,
		PageNo: 1,
		PageSize: 10,
		tabsKey: '1',
		rowData: [],
		selectedRowKeys: [],
		selectedRows: [],
		referralColumn: [],
		initReferralColumn: [
			{
				title: '序号',
				dataIndex: 'title',
				key: 'title',
				width: 80,
				align: 'center',
				isShow: true,  //表头列合
				render: (text, record, index) => {  //生成序号
					return (
						<span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>
					)
				},
			},
			{
				title: "转诊状态",
				dataIndex: "REFERRAL_STATUS_NAME",
				key: "REFERRAL_STATUS_NAME",
				align: 'center',
				width: 100,
				isShow: true,
				render: exam => <span style={{ color: (exam === '转诊中' ? '#0FA7E9' : (exam === '已转诊' ? '#3CBA61' : (exam === '转诊失败' ? '#F04249' : '#000'))) }}>{exam}</span>

			},
			{
				title: "转诊进程",
				dataIndex: "REFERRAL_PROCESS_NAME",
				key: "REFERRAL_PROCESS_NAME",
				align: 'center',
				width: 100,
				isShow: true,
				render: exam => <span
					style={{ color: (exam === '已接收' ? '#0FA7E9' : (exam === '已出院' ? '#3CBA61' : (exam === '已退回' ? '#F04249' : '#000'))) }}>{exam}</span>
			},
			{
				title: "姓名",
				dataIndex: "NAME",
				key: "NAME",
				align: 'center',
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							<span>{text}</span>
						</Tooltip>
					)
				}
			},
			{
				title: "性别",
				dataIndex: "SEX_NAME",
				key: "SEX_NAME",
				align: 'center',
				width: 80,
				isShow: true,
			},
			{
				title: "年龄",
				dataIndex: "AgeDisPlay",
				key: "AgeDisPlay",
				align: 'center',
				width: 80,
				isShow: true,
			},
			{
				title: "出生日期",
				dataIndex: "BIRTHDAY",
				key: "BIRTHDAY",
				align: 'center',
				width: 110,
				isShow: true,
				render: (val) => (
					<span>
						{val && moment(val).format("YYYY-MM-DD")}
					</span>
				),
			},
			{
				title: "手机号",
				dataIndex: "CONTACT_TEL",
				key: "CONTACT_TEL",
				align: 'center',
				width: 120,
				isShow: true
			},
			{
				title: "创建日期",
				dataIndex: "CREATE_DATE",
				key: "CREATE_DATE",
				align: 'center',
				width: 120,
				isShow: true,
				render: (val) => (
					<span>
						{val && moment(val).format("YYYY-MM-DD")}
					</span>
				),
			},
			{
				title: "转诊编号",
				dataIndex: "REFERRAL_UID",
				key: "REFERRAL_UID",
				align: 'center',
				width: 120,
				isShow: true,
			},
			{
				title: "转诊医院",
				dataIndex: "REFERRAL_HOSPITAL_NAME",
				key: "REFERRAL_HOSPITAL_NAME",
				align: 'center',
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							<span>{text}</span>
						</Tooltip>
					)
				}
			},
			{
				title: "申请科室",
				dataIndex: "REQ_DEPT_NAME",
				key: "REQ_DEPT_NAME",
				align: 'center',
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							<span>{text}</span>
						</Tooltip>
					)
				}
			},
			{
				title: "申请医生",
				dataIndex: "REQ_DOCTOR_NAME",
				key: "REQ_DOCTOR_NAME",
				align: 'center',
				width: 100,
				isShow: true,
			},
			{
				title: "申请转诊时间",
				dataIndex: "APPLY_REFERRAL_DATE",
				key: "APPLY_REFERRAL_DATE",
				align: 'center',
				width: 160,
				isShow: true,
				sorter: (a, b) => new Date(a.APPLY_REFERRAL_DATE).getTime() - new Date(b.APPLY_REFERRAL_DATE).getTime(),
				render: (val) => (
					<span>
						{val && moment(val).format("YYYY-MM-DD")}
					</span>
				),
			},
			{
				title: "预计转诊时间",
				dataIndex: "EXPECT_REFERRAL_DATE",
				key: "EXPECT_REFERRAL_DATE",
				align: 'center',
				width: 160,
				isShow: true,
				sorter: (a, b) => new Date(a.EXPECT_REFERRAL_DATE).getTime() - new Date(b.EXPECT_REFERRAL_DATE).getTime(),
				render: (val) => (
					<span>
						{val && moment(val).format("YYYY-MM-DD")}
					</span>
				),
			},
			{
				title: "退回原因",
				dataIndex: "REJECT_REASON",
				key: "REJECT_REASON",
				align: 'center',
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							<span>{text}</span>
						</Tooltip>
					)
				}
			},
		],
	}

	componentDidMount() {
		this.getCommonColumnInfo()
		this.queryReferralData()
		this.isFromApply()
	}
	//判断是否是从远程申请过来的转诊申请
	isFromApply = () => {
		let location = window.location.search.split('&')[1];
		if (location) {
			let examId = location.split('=')[1];
			getExamInfo(examId).then(res => {
				if (res && res.Status === 1) {
					this.setState({
						rowData: res.Result,
						isModalVisible: true,
						clickType: 'Add'
					}, () => {
						this.props.history.push('/siderPage?key=8')
					})
				}else{
					requestErrorLog('', '患者转诊-判断是否是从远程申请过来的转诊申请报错', 0,true)
				}
			})
		}
	}

	handleHeader = () => { // 点击表头
		this.setState({
			showColumn: true
		});
	}

	//获取、更新表头设置
	getCommonColumnInfo = (newTabData) => {
		let referralColumn;
		if (this.state.tabsKey === '1') {
			newTabData = newTabData || JSON.parse(localStorage.getItem("referralTabSetting1")) || this.state.initReferralColumn;
			referralColumn = getCommonColumnInfoFn(this.state.initReferralColumn, newTabData, 'referralTabSetting1')
		} else {
			newTabData = newTabData || JSON.parse(localStorage.getItem("referralTabSetting2")) || this.state.initReferralColumn;
			referralColumn = getCommonColumnInfoFn(this.state.initReferralColumn, newTabData, 'referralTabSetting2')
		}
		this.setState({
			referralColumn,
		})
	}

	queryReferralData = () => { //获取列表数据
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		this.refs.referralFormRef.validateFields((err, values) => {

			if (!err) {
				if (values.startTime > values.endTime) {
					message.error('开始时间不得大于结束时间')
					return;
				}
				let param = {
					...values,
					Type: "ReferralData",
					hospital_Code: userInfo.HOSPITAL_CODE,//所属医院
					Query_Referral: this.state.tabsKey === '1' ? 0 : 1,//查询类型(0:申请转诊;1:已完成转诊)
					Referral_Status: values.Referral_Status || '',
					hospitalItemDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
					PageNo: this.state.PageNo,//页数
					PageSize: this.state.PageSize//条数
				}
				getReferralData(param).then((res) => {
					if (res && res.Status === 1) {
						// 获取列表数据及总条数
						this.setState({
							tabsloading: false,
							referralData: res.Result,
							RowCount: res.ResponseModel.RowCount
						})
					}else{
						requestErrorLog('', '患者转诊-获取列表数据报错', 0,true)
					}
				})
			}
		})
	}

	handleAddPatient = () => {  // 新建转诊
		this.setState({
			rowData: [],
			selectedRowKeys: [],
			isModalVisible: true,
			clickType: 'Add'
		});
	};

	handleEditPatient = () => {  //编辑查看
		const { selectedRowKeys } = this.state
		if (selectedRowKeys.length === 1) {
			this.setState({
				isModalVisible: true,
				clickType: "Update",
			});
		} else {
			message.warning({ content: ("请选择一条病例进行编辑") });
		}
	};

	judgeApplyReferralStatus(rowData) { //判断是否可以申请转诊
		for (let i = 0; i < rowData.length; i++) {
			switch (rowData[i].REFERRAL_STATUS_NAME) {
				case "转诊中":
					Modal.info({ content: ("转诊中，不允许重复申请") });
					return false
				case "已转诊":
					Modal.info({ content: ("已转诊，不允许重复申请") });
					return false
				default:
					break;
			}
		}
		return true
	}

	handleApplyReferral = () => { //申请转诊
		const { rowData } = this.state
		if (rowData.length > 0) {
			if (this.judgeApplyReferralStatus(rowData)) {
				this.setState({
					applyVisible: true
				})
			}
		} else {
			message.warning("请先选择一条或者多条数据进行申请")
		}
	}

	handleCancelReferral = () => { //取消转诊
		const { rowData, selectedRowKeys } = this.state
		if (rowData.length > 0) {
			if (rowData.find(item => item.REFERRAL_STATUS_NAME === "未转诊") || rowData.find(item => item.REFERRAL_STATUS_NAME === "转诊失败")) {//只有转诊中的病例可以取消转诊
				message.warning("该状态不能取消转诊")
				return
			}
			if (rowData.find(item => item.REFERRAL_STATUS_NAME === "转诊中")) {
				let param = {
					Type: "CancelReferral",
					REFERRAL_UID: selectedRowKeys.toString()
				}
				getCancelReferral(param).then((res) => {
					if (res && res.Status === 1) {
						message.success("成功取消转诊")
						this.resetQueryList()
						this.setState({
							rowData: [],
							selectedRowKeys: []
						})
					}else{
						requestErrorLog('', '患者转诊-取消转诊报错', 0,true)
					}
				})
			}
		} else {
			message.warning("请先选择需要取消的病例")
		}
	}

	handleDeleteReferral = () => { //删除转诊
		const { rowData, selectedRowKeys } = this.state
		if (rowData.length > 0) {
			let param = {
				Type: "DELETE",
				REFERRAL_UID: selectedRowKeys.toString()
			}
			confirm({
				title: '删除转诊',
				content: '确认删除该转诊吗？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => {
					getDeleteReferred(param).then((res) => {
						if (res && res.Status === 1) {
							message.success("删除成功");
							this.resetQueryList()
						}else{
							requestErrorLog('', '患者转诊-删除转诊报错', 0,true)
						}
					})
				},
			});
		} else {
			message.warning("请先选择一条或者多条数据进行删除")
		}
	}

	onChangePage = (page, PageSize) => { //切换页码时重新赋值
		this.setState({
			PageNo: page,
			tabsloading: true,
		}, () => {
			this.queryReferralData()
		})
	}

	changeActivekey = (key) => { //切换tabs
		this.setState({
			tabsKey: key,
			tabsloading: true,
			selectedRowKeys: [],
			rowData: []
		}, () => {
			this.resetQueryList()
			this.getCommonColumnInfo()
		})
	}

	onClickRow = (record) => {  //单击行事件 
		let peferralUid = []
		peferralUid.push(record.REFERRAL_UID);
		this.setState({
			selectedRowKeys: peferralUid,
			rowData: [record]
		})
	}

	onSelect = (record, selected) => {
		const { rowData, selectedRowKeys } = this.state
		if (selected) {
			rowData.push(record)
			selectedRowKeys.push(record.REFERRAL_UID)
		}
		if (!selected) {
			for (let i = 0; i < rowData.length; i++) {
				if (rowData[i].REFERRAL_UID === record.REFERRAL_UID) {
					rowData.splice(i, 1);
					selectedRowKeys.splice(i, 1)
					i--;
				}
			}
		}
		this.setState({ rowData })
	}

	onSelectAll = (selected, selectedRows, changeRows) => { //全选操作
		const { rowData, selectedRowKeys } = this.state
		if (selected) {
			changeRows.forEach((item) => {
				selectedRowKeys.push(item.REFERRAL_UID)
				rowData.push(item)
			})
		}
		if (!selected) {
			for (let i = 0; i < rowData.length; i++) {
				for (let j = 0; j < changeRows.length; j++) {
					if (rowData[i].REFERRAL_UID === changeRows[j].REFERRAL_UID) {
						rowData.splice(i, 1);
						selectedRowKeys.splice(i, 1)
						i--;
						break;
					}
				}
			}
		}
		this.setState({ rowData })
	}

	resetQueryList = () => { //查询重置页码为1
		this.setState({
			PageNo: 1,
			PageSize: 10,
			rowData: [],
			selectedRowKeys: []
		}, () => {
			this.queryReferralData()
		})
	}

	handleChangeReset = () => { //重置
		this.refs.referralFormRef.resetFields();
	}

	setRowClassName = (record) => { //选中行样式
		return record === this.state.rowData ? 'clickRowStyl' : '';
	}

	render() {
		const { isModalVisible, clickType, applyVisible, referralColumn, selectedRowKeys, showColumn, referralData, rowData, tabsKey, tabsloading } = this.state
		const rolePrivilege = JSON.parse(localStorage.getItem('roleList')) || []
		return (
			<>
				<div className="tabs_wrap">
					<div onClick={this.handleAddPatient}>
						<img src={addReferral} alt='' style={{ width: '33px', marginLeft: '27px' }}></img>
						<p>新建转诊</p>
					</div>
					<div onClick={this.handleEditPatient}>
						<Icon type="monitor" className="icon" />
						<p>编辑查看</p>
					</div>
					{
						rolePrivilege.indexOf("申请会诊") > -1 ?
							<div onClick={this.handleApplyReferral}>
								<img src={replyicon} style={{ width: '33px', marginLeft: '30px', marginBottom: '5px', marginTop: '4px' }} alt=''></img>
								<p>申请转诊</p>
							</div> : null
					}
					{
						tabsKey === '1' ? //已完成转诊列表--不允许取消转诊
							<div onClick={this.handleCancelReferral}>
								<img src={noapplyicon} alt='' style={{ width: '33px', marginLeft: '27px', marginBottom: '5px', marginTop: '4px' }}></img>
								<p>取消转诊</p>
							</div> : null
					}
					{
						rolePrivilege.indexOf("删除病历") > -1 ?
							<div onClick={this.handleDeleteReferral}>
								<Icon type="delete" className="icon" />
								<p>删除转诊</p>
							</div> : null
					}
				</div>
				<div className='selectReferralBtn'>
					<ReferralQueryFrom
						ref='referralFormRef'
						queryReferralData={this.queryReferralData}
						tabsKey={tabsKey}
						onRef={(ref) => {
							this.ReferralQueryFrom = ref
						}} />
					<Button onClick={this.resetQueryList}>查询</Button>
					<Button onClick={this.handleChangeReset} style={{ marginLeft: '10px' }}>重置</Button>
				</div>
				<div className="eleWrap applyTd">
					<Tabs type="card" onChange={this.changeActivekey}>
						<TabPane tab="申请转诊" key="1">
							<Spin size="large" spinning={tabsloading} tip="Loading...">
								<Table
									rowClassName={this.setRowClassName}//表格行的类名
									columns={referralColumn}
									dataSource={referralData}
									rowKey={(record) => record.REFERRAL_UID} //需要修改为唯一的ID！
									scroll={{ x: 380, scrollToFirstRowOnChange: true }}
									pagination={{
										total: this.state.RowCount,
										current: this.state.PageNo,
										onChange: this.onChangePage,
									}}
									rowSelection={{
										selectedRowKeys,
										rowData,
										onSelect: this.onSelect,
										onSelectAll: this.onSelectAll
									}}
									onRow={record => {
										return {
											onClick: e => { this.onClickRow(record) },//点击行
										}
									}}
									onHeaderRow={column => {
										return {
											onDoubleClick: e => this.handleHeader(column)//修改表头
										}
									}}
								/>
							</Spin>
						</TabPane>

						<TabPane tab="已完成转诊" key="2">
							<Spin size="large" spinning={tabsloading} tip="Loading...">
								<Table
									rowClassName={this.setRowClassName}//表格行的类名
									columns={referralColumn}
									dataSource={referralData}
									rowKey={(record) => record.REFERRAL_UID} // 需要修改为唯一的ID！
									scroll={{ x: 380, scrollToFirstRowOnChange: true }}
									pagination={{
										total: this.state.RowCount,
										current: this.state.PageNo,
										onChange: this.onChangePage,
									}}
									rowSelection={{
										selectedRowKeys,
										rowData,
										onSelect: this.onSelect,
										onSelectAll: this.onSelectAll
									}}
									onRow={record => {
										return {
											onClick: e => { this.onClickRow(record) },//点击行
										}
									}}
									onHeaderRow={column => {
										return {
											onDoubleClick: e => this.handleHeader(column)//修改表头
										}
									}}
								/>
							</Spin>
						</TabPane>
					</Tabs>
				</div>
				{/* 编辑表头 */}
				{
					showColumn ?
						<EditTable
							visible={showColumn}
							setTabData={JSON.parse(localStorage.getItem("referralTabSetting" + tabsKey)) || this.state.initReferralColumn}
							updateParent={this.getCommonColumnInfo}
							onRef={(ref) => { this.setState({ showColumn: ref.showColumn }) }} /> : null
				}
				{/* 新建转诊 */}
				{
					isModalVisible ?
						<ReferralPatient
							visible={isModalVisible}
							clickType={clickType}
							rowData={rowData[0] ? rowData[0] : rowData}
							refreshTable={this.queryReferralData}
							onRef={(ref) => {
								this.setState({
									isModalVisible: ref.isModalVisible,
									applyVisible: ref.applyVisible,
									rowData: ref.applyReferralData || (rowData[0] && rowData[0].REFERRAL_UID ? rowData : []),
									selectedRowKeys: []
								});
							}} /> : null
				}
				{/* 申请转诊 */}
				{
					applyVisible ?
						<ApplyReferral
							visible={applyVisible}
							refreshTable={this.resetQueryList}
							rowData={rowData}
							onRef={(ref) => {
								this.setState({
									applyVisible: ref.applyVisible,
									// selectedRowKeys: []
								});
							}}
						/> : null
				}
			</>
		)
	}
}


export default Form.create()(ReferralApply);